import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { getEnv } from './index';
import packageJson from '@/../package.json';

Sentry.init({
  dsn: 'https://253d09906d614d2c97d818f0dfb0c3b6@sentry.wywk.cn/12',
  integrations: [new Integrations.BrowserTracing()],
  environment: getEnv(),
  release: packageJson.version,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.2,

  beforeBreadcrumb(breadcrumb) {
    if (breadcrumb.category === 'console' && breadcrumb.level !== 'error') {
      return null;
    }
    return breadcrumb;
  },
  beforeSend(event, hint: any) {
    const {
      originalException: { code },
    } = hint;

    if (code !== undefined && code !== 200) {
      return null;
    }
    return event;
  },
});
